export default [
    {
        path: 'usuario',
        component: () => import(
            /* webpackChunkName: 'cadastro-usuario' */
            '@/views/cadastro/usuario/Index'
        ),
        redirect: 'usuario/index',
        children: [
            {
                name: 'cadastro-usuario-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'cadastro-usuario' */
                    '@/views/cadastro/usuario/List.vue'
                ),
            },
            {
                name: 'cadastro-usuario-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'cadastro-usuario' */
                    '@/views/cadastro/usuario/Form.vue'
                ),
            },
            {
                name: 'cadastro-usuario-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'cadastro-usuario' */
                    '@/views/cadastro/usuario/Form.vue'
                ),
            },
        ],
    },
]